import { fontSizes } from '../../constants/constants';
import CustomInput from '../../components/CustomInput';
import Text from '../../components/Text';
import Button from '../../components/Button';
import ViewItems from '../../components/ViewItems';
import ClientCredentialsFunctional from './index.function';
import AuthWrapper from '../../components/AuthWrapper';
import { Formik } from 'formik';
import images from '../../constants/images';

import { client_Credentials_schema, client_Credentials_validation_schema } from '../../validations_schemas/client_Credentials_schema';
import { cn } from '../../utils/utils';
import { passwordRules } from '../../utils/functions';

const ClientCredentials = () => {
  const { TextWeight, authLoading, onsubmit, getContentKey, isArabic } = ClientCredentialsFunctional();

  return (
    <AuthWrapper>
      <ViewItems className={`w-full`}>
        <img src={images.textLogo} width={70} className={cn(isArabic ? 'self-end' : 'self-start')} />

        <Formik
          validationSchema={client_Credentials_validation_schema}
          initialValues={client_Credentials_schema}
          validateOnChange={false}
          validateOnMount={false}
          validateOnBlur={false}
          onSubmit={(values) => onsubmit(values, false)}
          className='w-full'
        >
          {({ handleSubmit, setFieldValue, setFieldError, values, errors }) => {
            const isValid = values?.username && values?.confirmPassword && values?.password;

            const rules = passwordRules(values?.password || '');
            const getOpacity = (isValid) => (isValid ? 'line-through opacity-50' : '');

            return (
              <>
                <Text
                  text={getContentKey('setup_corporate_credentials')}
                  weight={TextWeight.semiBold}
                  size={fontSizes.h18}
                  className={'mb-5 mt-10'}
                />

                <CustomInput
                  isRequired={true}
                  label={getContentKey('username')}
                  value={values?.username}
                  onChange={(e) => {
                    setFieldValue('username', e.target.value);
                    setFieldError('username', '');
                  }}
                  placeholder={getContentKey('placeholder_username')}
                  errorMessage={getContentKey(errors?.username)}
                  divClasses={'mt-4'}
                  canEnterSpace={false}
                />
                <CustomInput
                  isRequired={true}
                  label={getContentKey('password')}
                  value={values?.password}
                  onChange={(e) => {
                    setFieldValue('password', e.target.value);
                    setFieldError('password', '');
                  }}
                  isPassword
                  placeholder={getContentKey('placeholder_password')}
                  errorMessage={getContentKey(errors?.password)}
                  divClasses={'mt-4'}
                  canEnterSpace={false}
                />

                <ViewItems className='flex flex-col mt-3 gap-1'>
                  <Text text={getContentKey('one_lowercase_letter')}  size={fontSizes.h12} className={getOpacity(rules.lowercase)} />
                  <Text text={getContentKey('one_uppercase_letter')}  size={fontSizes.h12} className={getOpacity(rules.uppercase)} />
                  <Text text={getContentKey('one_numeric_character')}  size={fontSizes.h12} className={getOpacity(rules.numeric)} />
                  <Text
                    text={getContentKey('must_be_atleast_six_characters')}
                    size={fontSizes.h12}
                    className={getOpacity(rules.minLength)}
                  />
                </ViewItems>

                <CustomInput
                  isRequired={true}
                  label={getContentKey('confirmPassword')}
                  value={values?.confirmPassword}
                  onChange={(e) => {
                    setFieldValue('confirmPassword', e.target.value);
                    setFieldError('confirmPassword', '');
                  }}
                  isPassword
                  placeholder={getContentKey('placeholder_confirmPassword')}
                  divClasses={'mt-4'}
                  errorMessage={getContentKey(errors?.confirmPassword)}
                  canEnterSpace={false}
                />

                <ViewItems className={'w-full gap-1 mt-4'}>
                  <Button
                    text={getContentKey('submit_btn')}
                    className={'mt-6 my-2 w-full'}
                    onClick={handleSubmit}
                    loading={authLoading}
                    type={'submit'}
                    isDisabled={!isValid}
                  />
                </ViewItems>
              </>
            );
          }}
        </Formik>
      </ViewItems>
    </AuthWrapper>
  );
};

export default ClientCredentials;
